import { z } from 'zod';

export const billingNoteInputSchema = z.union([
  z.object({ templateId: z.number() }),
  z.object({ content: z.string().trim().min(1) }),
]);

export type BillingNoteInput = z.output<typeof billingNoteInputSchema>;
